<template>
  <v-app>

    <v-app-bar app color="dark" dark>
      <div class="d-flex align-center">
        <v-img
          alt="RosenRecords Logo"
          class="shrink mr-2"
          contain
          src="./assets/langlogo.png"
          transition="scale-transition"
          width="250"
        />
      </div>
      <v-spacer></v-spacer>
    
    </v-app-bar>

    <v-main>
      <LoadingSkeleton v-if="loading" />
      <router-view v-else />
    </v-main>


    <v-footer position="fixed" padless>
      <v-card class="flex" flat tile>
        <v-card-text class="py-2 white--text text-center">
          {{ new Date().getFullYear() }} © RosenRecords
        </v-card-text>
      </v-card>
    </v-footer>

  </v-app>
</template>

<script>

import LoadingSkeleton from "@/components/LoadingSkeleton.vue"

export default {
  name: 'App',

  components: {
    LoadingSkeleton
  },

  data: () => ({
     loading: true
  }),
  mounted() {
    // simulate initial load (or wait for real data)
    window.requestAnimationFrame(() => {
      this.loading = false
    })
  }
}
</script>
